import * as types from "./actions";
import APIUtil from "./../config/APIUtil";
import UrlConstants from "./../config/UrlConstants";
import * as code from "./../config/Constants";

/**
 * @desc Transactions - get All
 */
export function getAllTransactionsActionOld(status) {
  let url = UrlConstants.AdminCreateTransactionUrl;
  if (status) {
    url = url + "?status=" + status;
  }
  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: [],
        });
      }
      return response;
    });
  };
}

export function getAllTransactionsAction(status) {
  let data = {
    status: status,
  }
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.inprogressTransactionUrl,
      data,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: [],
        });
      }
      return response;
    });
  };
}

/**
 * @desc Transactions - get All
 */
export function getAllCalendarEventsAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.listAllCalendarEvents, true).then(
      (response) => {
        if (response.status == code.OK) {
          dispatch({
            type: types.CALENDAR_EVENTS,
            events: response.data,
          });
          return response.data;
        } else {
          dispatch({
            type: types.CALENDAR_EVENTS,
            events: [],
          });

          return [];
        }
      }
    );
  };
}

/**
 * @desc Transactions - upload property image
 */
export function uploadPropertyImageAction(data) {
  return function(dispatch) {
    return APIUtil.postFormDataMethod(
      UrlConstants.uploadPropertyImage,
      data,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.UPLOAD_PROPERTY_IMAGE,
          uploadSuccess: true,
        });
      } else {
        dispatch({
          type: types.UPLOAD_PROPERTY_IMAGE,
          uploadSuccess: false,
        });
      }
    });
  };
}

/**
 * @desc Transaction - get by ID
 */
export function getTransactionDataAction(id) {
  let url = UrlConstants.GetTransactionUrl;
  url = url.replace("{transactionsId}", id);

  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_TRANSACTION,
          transactionData: response.data.data[0],
        });
        return response.data.data[0];
      } else {
        dispatch({
          type: types.GET_TRANSACTION,
          transactionData: [],
        });

        return {};
      }
    });
  };
}

export function getPublicFormTransactionDataAction(id) {
  let data = {
    transactionId: id,
  };
return function(dispatch) {
  return APIUtil.postMethod(
    UrlConstants.getPublicformDetailsUrl,
    data,
    false
  ).then((response) => {
     if (response.status == code.OK) {
       dispatch({
         type: types.GET_TRANSACTION,
         transactionData: response.data.data[0],
       });
       return response.data.data[0];
     } else {
       dispatch({
         type: types.GET_TRANSACTION,
         transactionData: [],
       });
     }
    return response;
  });
};
}

/**
 * @desc Transaction - update by ID
 */
export function updateTransactionDataAction(id, data) {
  // console.log('updateTransactionDataAction id: ', id);
  // console.log('updateTransactionDataAction data: ', data);
  let url = UrlConstants.UpdateTransactionUrl;
  url = url.replace("{transactionsId}", id);

  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.UPDATE_TRANSACTION,
          updatedTransData: response.data,
        });
      } else {
        dispatch({
          type: types.UPDATE_TRANSACTION,
          updatedTransData: [],
        });
      }
      return response.data;
    });
  };
}

/**
 *
 * @desc Delete transaction api call
 */
export function deleteTransactionDataAction(id) {
  let url = UrlConstants.DeleteTransactionUrl;
  url = url.replace("{transactionsId}", id);

  return function(dispatch) {
    return APIUtil.deleteMethod(url, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.DELETE_TRANSACTION,
          isDTransDeleted: true,
        });
      } else {
        dispatch({
          type: types.DELETE_TRANSACTION,
          isDTransDeleted: false,
        });
      }
    });
  };
}

/**
 * @desc Transactions - get All Tasks
 */
export function getAllTasksAction(id) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.transactionEvent + "?transactionId=" + id,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_ALL_TASKS,
          tasks: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ALL_TASKS,
          tasks: [],
        });
      }
      return response;
    });
  };
}

/**
 * @desc Transactions - get All Tasks
 */
export function getTaskDetailsAction(id) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.transactionEvent + "/event?eventId=" + id,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_TASK_DETAILS,
          taskDetails: response.data,
        });
      } else {
        dispatch({
          type: types.GET_TASK_DETAILS,
          taskDetails: {},
        });
      }
      return response.data;
    });
  };
}

/**
 * @desc Transactions - Get Actual Values of Varibles/Tockens
 */
export function getActualValuesAction(id) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.transactionEvent + "/actual?eventId=" + id,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_ACTUAL_VALUES,
        });
      } else {
        dispatch({
          type: types.GET_ACTUAL_VALUES,
        });
      }
      return response.data;
    });
  };
}

/**
 *
 * @desc Delete Task/Event
 */
export function deleteTaskAction(id) {
  return function(dispatch) {
    return APIUtil.deleteMethod(
      UrlConstants.transactionEvent + "?id=" + id,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.DELETE_TASK,
        });
      } else {
        dispatch({
          type: types.DELETE_TASK,
        });
      }
      return response;
    });
  };
}

/**
 *
 * @desc User - Update Task
 */
export function updateTaskAction(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.transactionEvent + "?id=" + id,
      data,
      true
    ).then((response) => {
      if (response._id !== "") {
        dispatch({
          type: types.UPDATE_TASK,
        });
      } else {
        dispatch({
          type: types.UPDATE_TASK,
        });
      }
      if (response) {
        return response.data;
      } else {
        return [];
      }
    });
  };
}
/**
 * @desc Delete Comment
 */
export function deleteCommentAction(id, data) {
  return function(dispatch) {
    return APIUtil.deleteMethod(UrlConstants.comments + id, true, data).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.DELETE_COMMENT,
          });
        } else {
          dispatch({
            type: types.DELETE_COMMENT,
          });
        }
        return response;
      }
    );
  };
}

/**
 *
 * @desc Transacations - Create Task
 */
export function createTaskAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.transactionEvent, data, true).then(
      (response) => {
        if (response._id !== "") {
          dispatch({
            type: types.CREATE_TASK,
          });
        } else {
          dispatch({
            type: types.CREATE_TASK,
          });
        }
        return response;
      }
    );
  };
}

export function createAfterCareForm(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.aftercareFormSubmit,
      data,
      true
    ).then((response) => {
      return response;
    });
  };
}

/**
 * @desc User - Add Comment
 */
export function addCommentAction(data, eid) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.comments + eid, data, true).then(
      (response) => {
        if (response.status == code.OK) {
          dispatch({
            type: types.ADD_COMMENT,
            uploadSuccess: true,
          });
        } else {
          dispatch({
            type: types.ADD_COMMENT,
            uploadSuccess: false,
          });
        }
        return response;
      }
    );
  };
}

/**
 * @desc Transactions - status update
 */
export function changeTransactionStatusAction(transactionId, data) {
  let url = UrlConstants.transactionStatusUrl;
  url = url.replace("{transactionId}", transactionId);

  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.TRANSACTION_STATUS,
          transactionStatus: response.data,
        });
      } else {
        dispatch({
          type: types.TRANSACTION_STATUS,
          transactionStatus: [],
        });
      }
    });
  };
}

/**
 * @desc Transactions - status update
 */
export function updateDepedentTaskAction(taskId, data) {
  let url =
    UrlConstants.transactionEvent + "/dependency?transactioneventId=" + taskId;

  return function(dispatch) {
    return APIUtil.putMethod(url, data, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.TRANSACTION_DEPEDENDENT_TASK,
          transactionTaskStatus: response.data,
        });
      } else {
        dispatch({
          type: types.TRANSACTION_DEPEDENDENT_TASK,
          transactionTaskStatus: [],
        });
      }
    });
  };
}

/**
 * @desc Transactions - Get activity list
 */
export function getActivityAction(tId) {
  let url = UrlConstants.activitiesOfBuyerAgent + tId;

  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.TRANSACTION_ACTIVITY,
          transactionActivities: response.data.data,
        });
      } else {
        dispatch({
          type: types.TRANSACTION_ACTIVITY,
          transactionActivities: [],
        });
      }
    });
  };
}

/**
 * @desc Transactions - Get user list of transaction
 */
export function getActivityUsersAction(tId) {
  let url = UrlConstants.activityUser + tId;

  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.TRANSACTION_ACTIVITY_USER,
          activityUsers: response.data.data,
        });
      } else {
        dispatch({
          type: types.TRANSACTION_ACTIVITY_USER,
          activityUsers: [],
        });
      }
    });
  };
}

/**
 * @desc Transactions - Get user list of transaction
 */
export function getLeadSourceOptionsAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.leadSourceUrl, true).then(
      (response) => {
        if (response.status == code.OK) {
          dispatch({
            type: types.GET_LEAD_SOURCE_OPTIONS,
            options: response.data,
          });
        } else {
          dispatch({
            type: types.GET_LEAD_SOURCE_OPTIONS,
            options: [],
          });
        }

        return response.data || [];
      }
    );
  };
}

/**
 * @desc Transactions - Get user list of transaction
 */
export function addLeadSourceOptionsAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.leadSourceUrl, data, true).then(
      (response) => {
        if (response.status == code.OK) {
          dispatch({
            type: types.GET_LEAD_SOURCE_OPTIONS,
            options: response.data,
          });
        } else {
          dispatch({
            type: types.GET_LEAD_SOURCE_OPTIONS,
            options: [],
          });
        }

        return response.data || [];
      }
    );
  };
}

/**
 * @desc Transactions - Get user list of transaction
 */
export function deleteLeadSourceOptionsAction(id) {
  return function(dispatch) {
    return APIUtil.deleteMethod(
      UrlConstants.leadSourceUrl + "/" + id,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_LEAD_SOURCE_OPTIONS,
          options: response.data,
        });
      } else {
        dispatch({
          type: types.GET_LEAD_SOURCE_OPTIONS,
          options: [],
        });
      }

      return response.data || [];
    });
  };
}

/**
 * @desc Transactions - Get user list of transaction
 */
export function updateLeadSourceOptionsAction(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.leadSourceUrl + "/" + id,
      data,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_LEAD_SOURCE_OPTIONS,
          options: response.data,
        });
      } else {
        dispatch({
          type: types.GET_LEAD_SOURCE_OPTIONS,
          options: [],
        });
      }

      return response.data || [];
    });
  };
}

export function getContingenciesOptionsAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.contingencies, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.GET_ALL_CONTINGENCIES,
            options: response.data,
          });
        } else {
          dispatch({
            type: types.GET_ALL_CONTINGENCIES,
            options: [],
          });
        }

        return response.data || [];
      }
    );
  };
}

export function addContingenciesOptionsAction(data) {
  // console.log("addContingencyOptions");
  // console.log(data);
  return function(dispatch) {
    return APIUtil.postMethod(UrlConstants.contingencies, data, true).then(
      (response) => {
        if (response.status === code.OK) {
          dispatch({
            type: types.GET_ALL_CONTINGENCIES,
            options: response.data,
          });
        } else {
          dispatch({
            type: types.GET_ALL_CONTINGENCIES,
            options: [],
          });
        }

        return response.data || [];
      }
    );
  };
}

export function deleteContingenciesOptionsAction(id) {
  // console.log(id);
  return function(dispatch) {
    return APIUtil.deleteMethod(
      UrlConstants.contingencies + "/" + id,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_ALL_CONTINGENCIES,
          options: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ALL_CONTINGENCIES,
          options: [],
        });
      }

      return response.data || [];
    });
  };
}

export function editContingenciesOptionsAction(data, id) {
  return function(dispatch) {
    return APIUtil.putMethod(
      UrlConstants.contingencies + "/" + id,
      data,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_ALL_CONTINGENCIES,
          options: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ALL_CONTINGENCIES,
          options: [],
        });
      }

      return response.data || [];
    });
  };
}

/**
 * @desc Transactions - Check unique short name for transaction api
 */
export function checkTransShortNameAction(name) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.checkTransShortNameUrl + name,
      true
    ).then((response) => {
      if (response.status == code.ACCEPTED) {
        dispatch({
          type: types.CHECK_SHORT_NAME,
          shortNamaRes: response.data,
        });
      } else {
        dispatch({
          type: types.CHECK_SHORT_NAME,
          shortNamaRes: [],
        });
      }

      return response;
    });
  };
}

/**
 *
 * @desc Get list of variables
 */

export function getVarriableRefAction(tid) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.getVarriableRefTransactionUrl + tid,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.MASTER_TEMPLATE_GET_ALL_VERIABLE_REF,
          variablesRefs: response.data,
        });
      } else {
        dispatch({
          type: types.MASTER_TEMPLATE_GET_ALL_VERIABLE_REF,
          variablesRefs: [],
        });
      }
      return response.data;
    });
  };
}

/**
 * @desc Transactions - get special task
 */
export function getSpecialTaskAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.specialTask, true).then(
      (response) => {
        if (response.status == code.OK) {
          dispatch({
            type: types.GET_SPECIAL_TASKS,
            specialTask: response.data,
          });
        } else {
          dispatch({
            type: types.GET_SPECIAL_TASKS,
            specialTask: [],
          });
        }
        return response;
      }
    );
  };
}

/**
 * @desc get timezone list
 */
export function getTimezoneListAction() {
  return function(dispatch) {
    return APIUtil.getMethod(UrlConstants.timezoneUrl, true).then(
      (response) => {
        if (response.status == code.OK) {
          dispatch({
            type: types.GET_TIME_ZONE,
            timezoneList: response.data,
          });
        } else {
          dispatch({
            type: types.GET_TIME_ZONE,
            timezoneList: [],
          });
        }

        return response.data || [];
      }
    );
  };
}

/**
 * @desc Transactions - get All Transactions by post method 2-12-2022 :: New api
 */
export function getAllTransactionsActionWithPagination(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.AdminCreateTransactionUrl + "/withpagination",
      data,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: [],
        });
      }
      return response;
    });
  };
}

/**
 * @desc Transactions - get All
 */
export function getAllTransactionsActionNew(id) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.AdminCreateTransactionUrlNew,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: [],
        });
      }
      return response;
    });
  };
}

/**
 * @desc Transactions - get All
 */
export function getAllTransactionsActionFromAdmin(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.AdminCreateTransactionUrl + "/allTransaction",
      data,
      true
    ).then((response) => {
      if (response.status == code.OK) {
      } else {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: [],
        });
      }
      return response;
    });
  };
}

/**
 * @desc Transactions - get All - with invoice details for payment calculation
 */
export function getAllTransactionsActionFromAdminWithInvoice(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.AdminCreateTransactionUrl + "/getRevenueReport",
      data,
      true
    ).then((response) => {
      if (response.status == code.OK) {
      } else {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: [],
        });
      }
      return response;
    });
  };
}

/**
 * @desc get all appointments on calendar
 */
export function getAllAppointmentsAction(ownerId) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.getAllAppointmentsUrl + "/" + ownerId,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.CALENDAR_EVENTS,
          events: response.data,
        });
        return response.data;
      } else {
        dispatch({
          type: types.CALENDAR_EVENTS,
          events: [],
        });

        return [];
      }
    });
  };
}

/**
 * @desc Transactions - get All special Appointment Tasks of vendor
 */
export function getVendorSpecialAppoTasksAction() {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.transactionEvent + "/vendorOwnerSpecialEvents",
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_TASK_DETAILS,
          taskDetails: response.data,
        });
      } else {
        dispatch({
          type: types.GET_TASK_DETAILS,
          taskDetails: {},
        });
      }
      return response.data;
    });
  };
}

/**
 * @desc Transactions - get All Tasks
 */
export function getAllTasksActionwithResptTocontingecies(
  transactionId,
  contingencie
) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.transactionEvent +
        "/getTransactioneventDataByContingency" +
        "?transactionId=" +
        transactionId +
        "&&contingencie=" +
        contingencie,
      true
    ).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_ALL_TASKS,
          tasks: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ALL_TASKS,
          tasks: [],
        });
      }
      return response;
    });
  };
}

/**
 * @desc Transactions - get All for intake form
 */
export function getAllTransactionsForFormsOnPermissionAction(status) {
  let url = UrlConstants.AdminCreateTransactionUrl + "/formsTransactions";

  if (status) {
    url = url + "?status=" + status;
  }

  return function(dispatch) {
    return APIUtil.getMethod(url, true).then((response) => {
      if (response.status == code.OK) {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ALL_TRANSACTIONS,
          transactions: [],
        });
      }
      return response;
    });
  };
}

/**
 * @desc Transactions - get All Tasks
 */
export function getAllTasksActionByOwnerID(
  ownerID,
  payloadStartDate,
  payloadEndDate,
  contingencies
) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.transactionEvent +
        "/getAllTasksActionByOwnerID" +
        "?ownerID=" +
        ownerID +
        "&&payloadStartDate=" +
        payloadStartDate +
        "&&payloadEndDate=" +
        payloadEndDate +
        "&&conti=" +
        contingencies,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_ALL_TASKS,
          tasks: response.data,
        });
      } else {
        dispatch({
          type: types.GET_ALL_TASKS,
          tasks: [],
        });
      }
      return response;
    });
  };
}

/**
 * @desc User transaction payment
 */
export function userTransactionPaymentAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.cardInvoicesUrl + "/generatePaymentLink",
      data,
      true
    ).then((response) => {
      return response;
    });
  };
}

/**
 * @desc User transaction payment invoice listing
 */
export function getUserTransInvoiceAction(id) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.cardInvoicesUrl +
        "/transactionPaymentHistory?transactionId=" +
        id,
      true
    ).then((response) => {
      return response;
    });
  };
}

/**
 * @desc send client transaction payment link via email or text
 */
export function sendTransPaymentLinkAction(data) {
  return function(dispatch) {
    return APIUtil.postMethod(
      UrlConstants.cardInvoicesUrl + "/sendPaymentURL",
      data,
      true
    ).then((response) => {
      return response;
    });
  };
}
/**
 * @desc User transaction total payment
 */

export function getTransTotalPaymentAction(id) {
  return function(dispatch) {
    return APIUtil.getMethod(
      UrlConstants.cardInvoicesUrl + "/getTotalPayment?transactionId=" + id,
      true
    ).then((response) => {
      if (response.status === code.OK) {
        dispatch({
          type: types.GET_TRANS_TOTAL_PAYMENT,
          transPaymentData: response.data,
        });
      } else {
        dispatch({
          type: types.GET_TRANS_TOTAL_PAYMENT,
          transPaymentData: {},
        });
      }
      return response;
    });
  };
}
